import { useNavigate } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import React, { useState,useEffect  } from 'react';
import axios from 'axios';
import config from '../config';

const Login = () => {
  const { setToken } = useAuth();
  const navigate = useNavigate();

  const { token } = useAuth(); // Adjust according to your auth context/state management
  useEffect(() => {
    // Define the configuration object
   if (token) {
    navigate('/admin/dashboard');
  }
  }, [token, navigate]);

  const [mobileNumber, setMobileNumber] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [otp, setOtp] = useState('');
  const [showOtpField, setShowOtpField] = useState(false);
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [error, setError] = useState('');
  const [otpError,setOtpError] = useState('');
  const handleMobileNumberChange = (event) => {
      const newMobileNumber = event.target.value;
   
      setMobileNumber(newMobileNumber); 
      setIsValid(/^[6789]\d{9}$/.test(newMobileNumber));
     
  };
  const validatePhoneNumber = (number) => {
    if (number.trim() === '') {
      return 'Phone number is required.';
    }
    // Indian mobile numbers start with 7, 8, 9, or 6 and are 10 digits long.
    const regex = /^[6789]\d{9}$/;
    return regex.test(number) ? '' : 'Please enter a valid  mobile number.';
  };
 
  const handleGenerateOtp = async (e) => {
    e.preventDefault();
    const validationError = validatePhoneNumber(mobileNumber);
    if (validationError) {
      setError(validationError);
    } else {
      setError('');
      try {
        const response = await axios.post(`${config.backendUrl}/admin/generate_Otp`, {
          "mobile":mobileNumber
      
      });
      if (response.data?.statusCode === 201) {
        setShowOtpField(true);
      } else {
        setError(response.data?.message || 'Unable to send OTP.');
      }
        
      } catch (error) {
        setError(error.response?.data?.message || 'Unable to send OTP.');
      }
    }
    };
  const handleOtpChange = (event) => {
      const newOtp = event.target.value;
      setOtp(newOtp); 
      setIsValid(newOtp.length === 6);  
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); 
     if (!/^\d{6}$/.test(otp)) {
    setOtpError("OTP must be a 6-digit number.");
    return;
  }
    console.log('Verifying OTP:', otp);
    try {

      const response = await axios.post(`${config.backendUrl}/admin/validate_Otp`, {
        "mobile":mobileNumber,
        "otp":otp,
       
    });
    if (response.data?.statusCode !== 200 || !response.data?.Token) {
      throw new Error(response.data?.message || 'OTP verification failed.');
    }
    setToken(response.data.Token);
    navigate('/admin/dashboard');
    
      
    } catch (error) {

      
      console.error('Error sending OTP:', error);
      setOtpError(error.response?.data?.message || 'OTP verification failed.');

    }
   
  };
  return (
    <div className='login-container'> 
    
    <div className='logoheader flex justify-center'><img style={{height:"70px"}} src='../images/dilips-logo.png' alit="logo" />  </div>
    <form style={{background:"#fff",width:"100%"}}  onSubmit={showOtpField ? handleSubmit : handleGenerateOtp}>
        <h2 className='flex justify-center'>Login</h2>
        <div className='loginbody'> 
        <h3>Welcome</h3>
        <p className='font11 mb-4'>Please login to loyalty program by DILIPS INDIA</p>
      {showOtpField ? (
        <>
        <div> 
            <div className='mb-2'> 
            <input
                type="text"
                value={mobileNumber}
                onChange={handleMobileNumberChange}
                placeholder="Mobile Number"
                disabled  
            />
            </div>
            <div className='mb-2'> 
            <input
                type="text"
                value={otp}
                onChange={handleOtpChange}
                placeholder="OTP"
                className={isValid ? '' : 'input-invalid'}  
                required
            />
             {otpError && <div style={{ color: 'red', marginTop: '8px' }}>{otpError}</div>}
            </div>
          </div>
          <div className='text-right'><button className='redbtn' type="submit">Submit</button></div> 
        </>
      ) : (
        <div> 
            <div className='mb-2'> 
        <input
          type="text"
          value={mobileNumber}
          onChange={handleMobileNumberChange}
          placeholder="Mobile Number"
          className={isMobileValid ? '' : 'input-invalid'}  
          required
        />
        </div>
        {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}

       <div className='text-right'> <button type="button"  className='redbtn' onClick={handleGenerateOtp}>Generate OTP</button></div> 
        </div>
      )}
      </div>
    </form>
  <p className='flex justify-center mt-3'> Dilipsindia Loyalty Programme</p>
    </div>
  );
};

export default Login;